(() => {
  const year = value => {
    const match = String(value || '').match(/\b(1\d{3}|2\d{3})\b/);
    return match ? Number(match[0]) : null;
  };
  function init(root) {
    const grid = root.querySelector('[data-category-cards]');
    if (!grid || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-category-search]');
    const from = root.querySelector('[data-year-from]'), to = root.querySelector('[data-year-to]');
    const sort = root.querySelector('[data-category-sort]'), status = root.querySelector('[data-category-status]');
    const more = root.querySelector('[data-load-more]');
    let busy = false, failed = false;
    const visited = new Set([location.href]);
    root.querySelector('[data-category-tools]')?.removeAttribute('hidden');
    function render() {
      const cards = [...grid.querySelectorAll('[data-catalog-card]')];
      const query = (search?.value || '').trim().toLowerCase();
      const low = from?.value ? Number(from.value) : null, high = to?.value ? Number(to.value) : null;
      const invalid = low !== null && high !== null && low > high;
      from?.setAttribute('aria-invalid', String(invalid)); to?.setAttribute('aria-invalid', String(invalid));
      const title = card => card.dataset.title || card.querySelector('h2')?.textContent || '';
      const date = card => year(card.dataset.year) ?? year(title(card));
      cards.sort((a, b) => {
        const alphabetical = title(a).localeCompare(title(b), undefined, {numeric:true,sensitivity:'base'});
        if (sort?.value === 'az') return alphabetical;
        if (sort?.value === 'za') return -alphabetical;
        const ay = date(a), by = date(b);
        if (ay === null && by !== null) return 1;
        if (by === null && ay !== null) return -1;
        return ((ay ?? 0) - (by ?? 0)) * (sort?.value === 'newest' ? -1 : 1) || alphabetical;
      });
      let count = 0;
      cards.forEach(card => {
        const y = date(card);
        card.hidden = invalid || !(card.dataset.searchText || card.textContent).toLowerCase().includes(query) || ((low !== null || high !== null) && (y === null || (low !== null && y < low) || (high !== null && y > high)));
        if (!card.hidden) count++;
        grid.append(card);
      });
      if (status) status.textContent = invalid ? 'Enter a starting year no later than the ending year.' : `${count} of ${cards.length} titles${busy ? ' loaded — gathering remaining titles…' : '.'}${failed ? ' Some titles could not be loaded. Select Load more titles to retry.' : !count && !busy ? ' No matches. Try a wider year range or clear filters.' : ''}`;
    }
    [search, from, to].forEach(input => input?.addEventListener('input', render));
    sort?.addEventListener('change', render);
    root.querySelector('[data-category-reset]')?.addEventListener('click', () => {
      [search,from,to].forEach(input => {if(input) input.value = '';});
      if(sort) sort.value = 'oldest'; render();
    });
    async function load() {
      if (!more || more.hidden || busy) return;
      busy = true; failed = false; more.setAttribute('aria-disabled','true'); render();
      try {
        while (!more.hidden && root.isConnected) {
          const url = new URL(more.href, location.href);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalog page');
          const response = await fetch(url.href, {credentials:'same-origin',signal:AbortSignal.timeout(20000)});
          if (!response.ok) throw new Error('Catalog request failed');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const section = doc.querySelector('[data-np-category]');
          if (!section) throw new Error('Missing category');
          visited.add(url.href);
          const existing = new Set([...grid.querySelectorAll('[data-catalog-card] a:first-child')].map(a => a.getAttribute('href')));
          section.querySelectorAll('[data-category-cards] [data-catalog-card]').forEach(card => {
            const link = card.querySelector('a')?.getAttribute('href');
            if (!link || !existing.has(link)) {grid.append(document.importNode(card,true)); if(link) existing.add(link);}
          });
          const next = section.querySelector('[data-load-more]')?.getAttribute('href');
          more.hidden = !next;
          if (next) more.href = new URL(next,url).href;
          render();
        }
      } catch (_) {failed = true;}
      finally {busy = false; more.removeAttribute('aria-disabled'); render();}
    }
    more?.addEventListener('click', event => {event.preventDefault();load();});
    render(); load();
  }
  document.querySelectorAll('[data-np-category]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-np-category]').forEach(init));
})();
